import React from 'react';
import Link from 'gatsby-link';
import Logo from '../components/logo/Logo'

const colors = ['primary', 'dark', 'danger', 'warning', 'info', 'accent', 'success'];
const pageSize = 10;

export default class BlogPage extends React.Component {
  constructor(props) {
    super(props);

    const posts = this.props.data.allMarkdownRemark.edges.filter(post => post.node.frontmatter.templateKey === 'blog-post');
    const tagColors = {};
    let tags = [];

    posts.forEach(post => {
      if (post.node.frontmatter.tags && post.node.frontmatter.tags.length) {
        tags = tags.concat(post.node.frontmatter.tags);
      }
    });

    // Remove duplicates.
    tags
      .filter((el, i, a) => i === a.indexOf(el))
      .forEach((tag, i) => {
        if (i >= colors.length) {
          i = 0;
        }

        tagColors[tag.toUpperCase()] = colors[i]
      });

    this.state = {
      posts: posts,
      original: posts,
      tagColors: tagColors,
      pageSize: pageSize,
      diff: posts.length - pageSize
    };
  }

  filterList(event) {
    const posts = event.target.value
      ? this.state.original.filter((item) => {
        return JSON.stringify(item).toLowerCase().includes(event.target.value);
      })
      : this.state.original;

    this.setState({ posts });
  }

  showAll() {
    this.setState({ pageSize: 0, hideMoreBtn: true });
  }

  render() {
    return (
      <section className="section page page-no-padding blog-page">
        <header style={{ backgroundImage: `url(/img/blog-bg.jpg)` }}>
          <div className="container animate fade-in animate-delay-0x">
            <div className="row">
              <div className="col-sm-6">
                <div className="align-self-center text-center title">
                  <Logo size="xl" color="white" />
                  <h1 className="subheading text-center text-secondary">
                    <small><i>BLOG & TUTORIALS</i></small>
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </header>

        <div className="container blog-container">
          <div className="row">
            <div className="col-xs-12 col-sm-6">
              <h1 className="fancy">
                Recent Posts
              </h1>
            </div>
            <div className="col-xs-12 col-sm-6">
              <div className="input-group input-group-lg pull-right">
                <input onChange={this.filterList.bind(this)} type="text" className="form-control" aria-label="Large" placeholder="Search..." aria-describedby="inputGroup-sizing-sm" />
                <div className="input-group-prepend">
                  <span className="input-group-text" id="inputGroup-sizing-lg">
                    <i className="fa fa-search" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>

          {this.state.posts.slice(0, this.state.pageSize ? this.state.pageSize : this.state.posts.length).map((item, index) => {
            return (
              <div className="card text-white bg-secondary mb-3 animate fade-in" key={item.node.id}>
                <div className="card-header">
                  <strong>{item.node.frontmatter.title}</strong>
                  <span className="badge badge-light pull-right">{item.node.frontmatter.date}</span>
                </div>
                <div className="card-body">
                  <h5 class="card-title">{item.node.frontmatter.description}</h5>
                  <p className="card-text">
                    {item.node.excerpt}
                  </p>
                  <Link className="btn btn-outline-warning" to={item.node.frontmatter.path}>
                    Read More
                  </Link>

                  <div className="tags pull-right">
                    {item.node.frontmatter.tags && item.node.frontmatter.tags.map(tag => {
                      return <span key={tag} className={'badge badge-' + (this.state.tagColors[tag.toUpperCase()] || 'primary')}>{tag.toUpperCase()}</span>
                    })}
                  </div>

                </div>
              </div>
            );
          })}

          <hr />
          <h6>
            Have a specific topic you'd like me to write about? <Link to="/contact">
              Let me know!
            </Link>
          </h6>
        </div>

        {!this.state.hideMoreBtn && this.state.diff && this.state.diff > 1 &&
          <div className="container text-center cushy-top">
            <button className="btn btn-lg btn-secondary" onClick={this.showAll.bind(this)}>
              <i className="fa fa-plus" aria-hidden="true"></i> View {this.state.diff} More Projects
          </button>
          </div>
        }
      </section>
    );
  }
}

export const pageQuery = graphql`
  query BlogQuery {
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          excerpt(pruneLength: 400)
          id
          frontmatter {
            title
            description
            templateKey,
            tags
            date(formatString: "MMMM DD, YYYY")
            path
          }
        }
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/templates/blog-page.js